/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

import Radio, { RadioItem } from '../Radio/Radio'
import { pageSubtitleCss } from '../../../../lib/styles/typography'
import { fieldsetCss, srOnlyCss } from '../../../../lib/styles/cssStyles'

const radioGroupCss = css`
  padding: 9px 0px;
`

type RadioGroupProps = {
  /** A11y label for the group */
  ariaLabel?: string
  /** Callback whenever the radio selection changes */
  onChange: (value: string) => void
  /** Options to be rendered as Radios within this group */
  options: Array<RadioItem>
  /** Value of the selected option */
  selectedOption: string
  /** Title for the RadioGroup */
  title?: string
}

const defaultProps: Pick<RadioGroupProps, 'ariaLabel' | 'title'> = {
  ariaLabel: undefined,
  title: undefined
}

const RadioGroup = ({ ariaLabel, onChange, options, selectedOption, title }: RadioGroupProps) => (
  <div css={radioGroupCss} role="radiogroup" aria-label={ariaLabel || title}>
    {title && <div css={pageSubtitleCss}>{title}</div>}
    <fieldset css={fieldsetCss}>
      <legend>
        <span css={srOnlyCss}>{`${title} radio group`}</span>
      </legend>
      {options.map((o: RadioItem) => (
        <Radio
          description={o.description}
          groupName={title || ariaLabel}
          key={o.value}
          label={o.label}
          onSelect={() => onChange(o.value)}
          isSelected={selectedOption === o.value}
          value={o.value}
        />
      ))}
    </fieldset>
  </div>
)

RadioGroup.defaultProps = defaultProps

export default RadioGroup
